module.exports = __webpack_public_path__ + "static/media/app.19e6bbed.png";